import { domMax } from 'framer-motion'

// В последних версиях framer-motion изменился API для LazyMotion.
// Вместо массива функций теперь используется объект с набором функций.
// Готовые наборы: `domAnimation` (анимации + жесты) и `domMax` (все функции).
//
// Так как в приложении используется `layout` анимация, нам необходим `domMax`.
// Он включает в себя `layout`, `drag`, `gestures` и `animation`.
// Создание более гранулярного набора (например, без `drag`) больше
// не поддерживается через стандартный API.
export const customFeatures = domMax
